export default function pluralize(text: string, occurrences: number, pluralWord?: string) {
  if (occurrences > 1) {
    return pluralWord || `${text}s`;
  }
  return text;
}
